import React, { useState } from 'react';
import { Table } from '../common';
import Paginator from '../common/tables/Paginator';
import AWSPortOpeningRequest from '../../models/entities/AWSPortOpeningRequests';
import ApprovalsAWSPORsTableRow from './ApprovalsAWSPORsTableRow';

interface ApprovalsAWSPORsTableProps {
    filteredAWSPORs: AWSPortOpeningRequest[];
}

const ApprovalsAWSPORsTable = ({
    filteredAWSPORs,
}: ApprovalsAWSPORsTableProps) => {
    const [awsPorsOnPage, setAWSPorsOnPage] = useState<AWSPortOpeningRequest[]>([]);
    return (
        <Table
            footer={
                <Paginator
                    data={filteredAWSPORs}
                    onPageChange={(awsPors: AWSPortOpeningRequest[]) => {
                        setAWSPorsOnPage(awsPors)
                    }}
                />
            }
        >
            <Table.Head>
                <Table.Head.Row>
                    <Table.Head.Cell>AWS POR #</Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>Account</Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>
                        Status
                    </Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>Action</Table.Head.Cell>
                </Table.Head.Row>
            </Table.Head>
            <Table.Body>
                {awsPorsOnPage.map((awsPor: AWSPortOpeningRequest) => {
                    return <ApprovalsAWSPORsTableRow
                        key={awsPor.id}
                        awsPor={awsPor}
                    />;
                }
                )}
            </Table.Body>
        </Table>
    );
}

export default ApprovalsAWSPORsTable;
